import { render } from "./Customer-Profile.vue?vue&type=template&id=73da1a43"
import script from "./Customer-Profile.vue?vue&type=script&lang=js"
export * from "./Customer-Profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__